const mapCountrysCurrency = {
  SA: "ar-SA",
  BD: "bn-BD",
  CZ: "cs-CZ",
  DK: "da-DK",
  AT: "de-AT",
  DE: "de-DE",
  GR: "el-GR",
  AU: "en-AU",
  CA: "en-CA",
  GB: "en-GB",
  IE: "en-IE",
  NZ: "en-NZ",
  US: "en-US",
  ZA: "en-ZA",
  AR: "es-AR",
  CL: "es-CL",
  CO: "es-CO",
  ES: "es-ES",
  MX: "es-MX",
  FI: "fi-FI",
  BE: "fr-BE",
  CH: "fr-CH",
  FR: "fr-FR",
  IL: "he-IL",
  IN: "hi-IN",
  HU: "hu-HU",
  ID: "id-ID",
  IT: "it-IT",
  JP: "ja-JP",
  KR: "ko-KR",
  NL: "nl-NL",
  NO: "no-NO",
  PL: "pl-PL",
  BR: "pt-BR",
  PT: "pt-PT",
  RO: "ro-RO",
  RU: "ru-RU",
  SK: "sk-SK",
  SE: "sv-SE",
  LK: "ta-LK",
  TH: "th-TH",
  TR: "tr-TR",
  CN: "zh-CN",
  HK: "zh-HK",
  TW: "zh-TW",
};

export function formatNumber(
  value: string | number,
  currency?: string,
  code?: string,
  decimalScale?: number,
): string {
  const locale = code ? mapCountrysCurrency[code as keyof typeof mapCountrysCurrency] : "en-US";

  const formatter = new Intl.NumberFormat(locale, {
    ...(currency && { style: "currency", currency: currency }),
  });

  const resolvedOptions = formatter.resolvedOptions();

  const fractionSeparator = formatter.format(1.1).replace(/[^,.]/g, "");

  const formatted = (value || 0)
    .toLocaleString(locale, {
      ...(currency && { style: "currency", currency: currency }),
      maximumFractionDigits: resolvedOptions.maximumFractionDigits || decimalScale || 2,
    })
    .replace("\u00A0", " ");

  if (currency && fractionSeparator) {
    //removes zeroed fractional part
    formatted.replace(new RegExp(`${fractionSeparator}00`), "");
  }

  return formatted;
}
